import { AUDITDATA, AUDITDATAFETCH } from './actionType'

// initialState shows what we are going to change
const initialState = {
  // empty data field
  data: null,
  // API call
  auditDataFetching: false,
}

// Checks the type of the action and returns the appropriate state
export default function auditReducer(state = initialState, action) {
  switch (action.type) {
    case AUDITDATAFETCH:
      // Boolean describing if the data is being gathered
      return Object.assign({}, state, {
        auditDataFetching: action.auditDataFetching,
      })
    case AUDITDATA:
      return Object.assign({}, state, {
        data: action.data,
      })
    default:
      // returns state as is without changes
      return state
  }
}
